<nav
  class="navbar sticky-top navbar-expand-lg navbar-light bg-white pb-md-0"
  id="navbar"
>
  <div class="container-fluid px-0">
    <div class="row g-0 w-100">
      <div
        class="d-none d-md-flex align-items-center justify-content-center bg-white gap-3"
      >
        <small class="mb-0 fs-12">Discover our products: </small>
        <ul class="list-inline mb-0 d-flex gap-3">
          <li class="list-inline-item">
            <a
              href="https://kreador.io"
              class="text-decoration-none text-dark fs-14"
            >
              Business Suite
            </a>
          </li>
          <li class="list-inline-item">
            <a class="text-decoration-none text-muted fs-14"> Core Banking </a>
          </li>
          <li class="list-inline-item">
            <a class="text-decoration-none text-muted fs-14">
              Payment Aggregrator
            </a>
          </li>
          <li class="list-inline-item">
            <a class="text-decoration-none text-muted fs-14"> Aide Finance </a>
          </li>
        </ul>
      </div>
      <div
        class="pt-2 d-flex align-items-center justify-content-between px-3 flex-wrap"
      >
        <a
          class="navbar-brand"
          routerLink="/"
          aria-label="logo"
          (click)="resetToHome()"
        >
          <img
            class="navbar-brand-logo"
            src="assets/icons/icon.png"
            alt="Kreador Logo"
          />
          <span class="fw-5 fs-16">Kreador</span>
          <p class="fs-10 text-muted">Business Suite</p>
        </a>
        <button
          class="navbar-toggler d-lg-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapsibleNavId"
          aria-controls="collapsibleNavId"
          aria-expanded="false"
          aria-label="Toggle navigation"
          #navbarToggler
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="collapsibleNavId">
          <ul class="navbar-nav mt-2 mt-lg-0">
            @for (nav of navigations; track $index) {
            <li class="nav-item">
              <a
                class="nav-link fs-14"
                [routerLink]="nav.url"
                routerLinkActive="active text-primary border-bottom border-primary border-2"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="navbarToggler.click()"
              >
                {{ nav.name }}
              </a>
            </li>
            }
          </ul>
          <div class="d-flex my-2 my-lg-0">
            <div class="dropdown open">
              <button
                class="btn btn-outline-secondary rounded-pill btn-sm text-nowrap"
                type="button"
                (click)="goToUrl('https://kreasaas.web.app')"
              >
                Sign in
              </button>
            </div>
            <button
              type="button"
              class="btn btn-primary rounded-pill ms-2 text-nowrap btn-sm"
              (click)="
                goToUrl(
                  'https://auth.kreador.io/realms/kreador-demo/login-actions/registration?client_id=saas-admin&tab_id=iiedOy4t90E&client_data=eyJydSI6Imh0dHBzOi8va3JlYXNhYXMud2ViLmFwcC8iLCJydCI6ImNvZGUiLCJybSI6ImZyYWdtZW50Iiwic3QiOiIzMGE2YjAyZi1jOGE3LTQ4MTAtOTQxZi05MGVjMGM5MGVkNzAifQ'
                )
              "
            >
              Get started
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
